import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteInvoiceRequestForm.FieldsSection', {
    customerDetailsSectionTitle: 'Customer Details',
    invoiceDetailsSectionTitle: 'Invoice Details',
    memoSectionTitle: 'Memo',
    textFieldPlaceholder: 'Enter value',
    dateFieldPlaceholder: 'Select date',
    customerFieldText: 'Customer',
    customerFieldPlaceholder: 'Select customer',
    billingAddressFieldText: 'Billing address',
    billingAddressPlaceholder: 'Select address',
    vatRegistrationFieldText: 'VAT registration',
    transactionNumberFieldText: 'Transaction number',
    transactionReferenceFieldText: 'Reference',
    transactionDateFieldText: 'Date',
    dueDateFieldText: 'Due date',
    startDateFieldText: 'Start date',
    endDateFieldText: 'End date',
    termsFieldText: 'Terms',
    termsFieldPlaceholder: 'Select terms',
    discountAmountFieldText: 'Discount amount',
    discountDateFieldText: 'Discount date',
    classFieldText: 'Class',
    classFieldPlaceholder: 'Select class',
    departmentFieldText: 'Department',
    departmentFieldPlaceholder: 'Select department',
    locationFieldText: 'Location',
    locationFieldPlaceholder: 'Select location',
    postingPeriodFieldText: 'Posting period',
    discountItemFieldText: 'Discount item',
    discountItemFieldPlaceholder: 'Select discount item',
    discountRateFieldText: 'Discount rate',
});
